import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiDocDesc } from '../docHelpers';

const getV11APIs = (userInfo) => {
  return [
    {
      title: '주문 수정',
      url: '/doc/주문 수정',
      data: [
        {
          version: 'v1.1',
          url: '/order/edit',
          desc: apiDocDesc({
            intro: '등록된 주문 정보를 수정합니다.',
            items: ['수령자 정보, 택배사, 송장번호 변경시 동일 묶음 주문의 데이터가 일괄 수정됩니다.'],
          }),
          method: 'PUT',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'uniq',
              required: 'O',
              type: 'String',
              desc: '주문 고유번호',
            },
            {
              title: 'shop_sale_name',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '주문상품명',
                notes: [
                  '<strong><code>|</code></strong>, <strong><code>#</code></strong> 및 지원하지 않는 이모티콘은 사용할 수 없습니다.',
                ],
              }),
            },
            {
              title: 'shop_opt_name',
              required: '',
              type: 'String',
              desc: '옵션명',
            },
            {
              title: 'sales',
              required: '',
              type: 'Number',
              desc: '판매금액',
            },
            {
              title: 'gift_name',
              required: '',
              type: 'String',
              desc: '사은품이름',
            },
            {
              title: 'order_name',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '주문자명',
                notes: ['한글, 영문, 숫자, 공백, - _ / ~ + , . ( )  [ ] % & \' 만 입력가능합니다.'],
              }),
            },
            {
              title: 'order_id',
              required: '',
              type: 'String',
              desc: '주문자아이디',
            },
            {
              title: 'order_tel',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '주문자 전화번호', notes: ['숫자, 하이픈(-)만 입력가능합니다.'] }),
            },
            {
              title: 'order_htel',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '주문자 핸드폰번호', notes: [' 숫자, 하이픈(-)만 입력가능합니다.'] }),
            },
            {
              title: 'to_name',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '수령자명',
                notes: ['한글, 영문, 숫자, 공백, - _ / ~ + , . ( )  [ ] % & \' 만 입력가능합니다.'],
              }),
            },
            {
              title: 'to_name_eng',
              required: '',
              type: 'String',
              desc: '수령자영문명',
            },
            {
              title: 'to_tel',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '수령자 전화번호', notes: ['숫자, 하이픈(-)만 입력가능합니다.'] }),
            },
            {
              title: 'to_htel',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '수령자 핸드폰번호', notes: ['숫자, 하이픈(-)만 입력가능합니다.'] }),
            },
            {
              title: 'to_zipcd',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '수령자 우편번호', notes: ['숫자, 하이픈(-)만 입력가능합니다.'] }),
            },
            {
              title: 'to_addr1',
              required: '',
              type: 'String',
              desc: '수령자주소',
            },
            {
              title: 'to_addr2',
              required: '',
              type: 'String',
              desc: '수령자주소상세',
            },
            {
              title: 'ship_method',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '배송방법',
                allowedValues: ['무료배송', '선결제', '착불', '방문수령', '퀵배송', '일반우편', '설치배송', '조건부배송', '기타'],
              }),
            },
            {
              title: 'ship_cost',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '배송비', notes: ['숫자만 입력가능합니다.'] }),
            },
            {
              title: 'ship_msg',
              required: '',
              type: 'String',
              desc: '배송메세지',
            },
            {
              title: 'depot_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '배송처번호', notes: ['배송처조회 API 를 통하여 확인된 배송처 번호를 입력해주십시오.'] }),
            },
            {
              title: 'gprivate_no',
              required: '',
              type: 'String',
              desc: '개인통관번호',
            },
            {
              title: 'carr_info',
              required: '',
              type: 'Object',
              desc: apiParamDesc({
                title: '택배정보 ',
                notes: [
                  '주문, 상품정보의 로그를 조회합니다.',
                  '로그 조회시 uniq, inq_uniq, prod_no, ol_shop_no 중의 하나의 호출정보는 반드시 입력해주셔야 합니다.',
                ],
              }),
            },
            {
              title: 'carr_no',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '택배사코드', sub: '(택배사코드조회 api를 호출하여 확인)' }),
              indent: 1,
            },
            {
              title: 'invoice_no',
              required: 'O',
              type: 'String',
              desc: '송장번호',
              indent: 1,
            },
          ],
          body_example: {
            uniq: '1596083929550784071',
            shop_sale_name: 'api 수동입력 테스트 주문',
            sales: '1000000730',
            gift_name: '',
            order_name: '김플토',
            order_id: 'plto_kim',
            order_tel: '02-3333-4444',
            order_htel: '010-2222-3333',
            to_name: '김플토',
            to_name_eng: 'kim pl to',
            to_tel: '02-3333-4444',
            to_htel: '010-2222-3333',
            to_zipcd: '08390',
            to_addr1: '서울특별시 구로구 디지털로26길 123 (구로동)',
            to_addr2: '14층 플레이오토',
            ship_method: '선결제',
            ship_cost: '2500',
            depot_no: '',
            carr_info: [
              {
                carr_no: '01',
                invoice_no: '',
              },
            ],
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object[]',
              desc: '결과상세',
            },
            {
              title: 'uniq',
              required: 'O',
              type: 'String',
              desc: '주문고유번호',
              indent: 1,
            },
            {
              title: 'bundle_no',
              required: 'O',
              type: 'String',
              desc: '묶음번호',
              indent: 1,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: '성공/실패 여부',
              indent: 1,
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '실패시 에러메시지',
              indent: 1,
            },
          ],
          response_example: [
            {
              result: [
                {
                  uniq: '3795927781274656794',
                  status: '성공',
                  result: [
                    '주문자명: 이플토->김플토',
                    '주문자전화번호: 01-2222-3333->02-3333-4444',
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: '배송정보 업데이트',
      url: '/doc/배송정보 업데이트',
      data: [
        {
          authorized_m_no: [1, 1957, 5422, 77327, 129725, 121024, 122081, 122082],
          authorized_aff_no: [1051],
          version: 'v1.1',
          url: '/order/setInvoice/v1.1',
          desc: apiDocDesc({
            items: [
              '입력한 묶음/패키지번호의 주문의 송장번호와 배송사를 업데이트 합니다.',
              '묶음/패키지번호 및 택배사번호, 송장번호는 모두 필수 값입니다.',
              'overwrite 는 이미 값이 입력되어있는경우 덮어쓸지 여부로 기본값은 false 입니다.',
              'change_complete 는 상태변경시 출고완료로 변경할건지의 여부입니다. 기본값은 false 이며 변경되는 상태는 다음과 같습니다. : false - 운송장출력 : true - 출고완료',
              'isPackage는 입력한 bundle_no가 묶음번호인지 또는 패키지번호인지의 여부입니다.',
              '결과 데이터는 전송한 묶음번호만큼 Array 로 리턴됩니다',
            ],
          }),
          method: 'PUT',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'orders',
              required: 'O',
              type: 'Array',
              desc: '변경할 주문데이터',
            },
            {
              title: 'bundle_no',
              required: 'O',
              type: 'String',
              desc: '묶음/패키지번호',
              indent: 1,
            },
            {
              title: 'carr_no',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '택배사코드', sub: '(택배사코드조회 api를 호출하여 확인)' }),
              indent: 1,
            },
            {
              title: 'invoice_no',
              required: 'O',
              type: 'String',
              desc: '송장번호',
              indent: 1,
            },
            {
              title: 'overwrite',
              required: '',
              type: 'boolean',
              desc: apiParamDesc({ title: '이미 송장번호가 입력되어있는 주문일경우 신규정보로 덮어쓸지 여부', defaultValue: 'false' }),
            },
            {
              title: 'dupl_doubt_except_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '중복의심주문 제외 여부',
                sub: '(\'Y\': 제외 후 작업, \'N\': 제외하지 않고 작업)',
                defaultValue: 'N',
              }),
            },
            {
              title: 'change_complete',
              required: '',
              type: 'boolean',
              desc: apiParamDesc({
                title: '송장번호와 택배사가 정상 반영된경우 변경할 주문상태',
                sub: '(true:출고완료, false:운송장출력)',
                defaultValue: 'false',
              }),
            },
            {
              title: 'isPackage',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '배송정보 업데이트 기준',
                sub: '(true:패키지번호 기준, false:묶음번호 기준)',
                defaultValue: 'false',
              })
            }
          ],
          body_example: {
            orders: [
              {
                bundle_no: '3772225519903274',
                carr_no: '4',
                invoice_no: '123123123123',
              },
              {
                bundle_no: '3772207204045999',
                carr_no: '5',
                invoice_no: '321321321321',
              },
            ],
            overwrite: true,
            change_complete: true,
          },
          response: [
            {
              title: 'bundle_no',
              required: 'O',
              type: 'String',
              desc: '주문 묶음/패키지번호',
            },
            {
              title: 'result',
              required: 'O',
              type: 'Boolean',
              desc: '성공, 실패 여부',
            },
            {
              title: 'message',
              required: 'O',
              type: 'Boolean',
              desc: '실패시 실패사유',
            },
          ],
          response_example: [
            {
              bundle_no: '3772225519903274',
              result: '성공',
              message: '',
            },
            {
              bundle_no: '3772207204045999',
              result: '실패',
              error_code: 'e2001',
              messages: [
                '[출고관리]메뉴에서 조회되지 않는 패키지번호입니다.'
              ],
            },
          ],
        },
      ],
    },
    {
      title: '주문상태변경',
      url: '/doc/주문상태변경',
      data: [
        {
          version: 'v1.1',
          url: '/orders/status',
          desc: apiDocDesc({
            items: [
              '입력한 묶음번호의 주문상태를 변경합니다.',
              '묶음번호와 uniqs를 둘다 입력하시는 경우 묶음번호 값은 무시되며 uniqs에 해당하는 주문건만 상태가 변경됩니다. (우선순위 1. uniqs 2. bundle_codes)',
              '주문 동기화 시 쇼핑몰 상태를 기준으로 주문 상태가 변경될 수 있으므로 사용 시 주의하시기 바랍니다.'
            ],
          }),
          method: 'PATCH',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'bundle_codes',
              required: '',
              type: 'String[]',
              desc: '주문묶음번호 리스트',
            },
            {
              title: 'uniqs',
              required: '',
              type: 'String[]',
              desc: '주문고유번호',
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '변경하려고 하는 주문상태',
                allowedValues: [
                  ['신규주문', '현재 주문상태가 <strong>[주문재확인, 주문보류, 출고대기, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['출고대기', '현재 주문상태가 <strong>[주문재확인, 운송장출력, 출고보류, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['배송중', '현재 주문상태가 <strong>[주문재확인, 출고완료, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['배송완료', '현재 주문상태가 <strong>[주문재확인, 출고완료, 배송중, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['판매완료', '현재 주문상태가 <strong>[주문재확인, 배송중, 배송완료, 구매결정, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['반품요청', '현재 주문상태가 <strong>[주문재확인, 교환요청, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['반품완료', '현재 주문상태가 <strong>[주문재확인, 반품요청, 반품접수, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['교환요청', '현재 주문상태가 <strong>[주문재확인, 반품요청, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['교환완료', '현재 주문상태가 <strong>[주문재확인, 교환요청, 교환접수, 취소완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['취소요청', '현재 주문상태가 <strong>[주문재확인, 신규주문, 주문보류, 출고대기, 운송장출력, 출고보류, 출고완료, 반품회수완료, 반품완료, 교환회수완료, 교환완료, 맞교환완료]</strong>인 경우에만 변경가능합니다.'],
                  ['취소완료', '현재 주문상태가 <strong>[주문재확인, 취소요청]</strong>인 경우에만 변경가능합니다.'],
                ],
              }),
            },
          ],
          body_example: {
            bundle_codes: [
              '3885441989781833',
              '3886782611074522',
              '3885942403359338',
            ],
            status: '신규주문',
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'String',
              desc: '성공, 실패여부',
            },
          ],
          response_example: {
            results: '성공',
          },
          error_example: {
            "error_code": "e2999",
            "messages": [
                "출고대기 주문상태변경은 출고보류, 주문재확인 상태의 주문건만 가능합니다."
            ]
        }
        },
      ],
    },
  ];
};

export default getV11APIs;
